import { Button, InputField } from '@design-system';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { useAnalyticsEmitter } from '../../../../utils/analytics/emitter';
import { PrivateSalesController } from '../../types/PrivateLink';
import { formatCodeValue, sanitisePassword } from '../../utils/password';

type Props = {
  privateSalesController: PrivateSalesController;
};

export const PasswordForm: React.FC<Props> = (props: Props) => {
  const { privateSalesController } = props;

  const [analyticsEmitter] = useAnalyticsEmitter();
  const { t } = useTranslation('private');
  const [password, setPassword] = useState<string>('');
  const [showValidation, setShowValidation] = useState(false);
  const form = useForm();

  const handleSubmit = form.handleSubmit(async () => {
    const sanitisedPassword = sanitisePassword(password);

    await privateSalesController.getPrivateLinkWithProducts(
      sanitisedPassword,
      analyticsEmitter,
    );

    setShowValidation(true);
  });

  const showCodeValidation =
    showValidation &&
    !privateSalesController.loading &&
    privateSalesController.locked;

  return (
    <div className="flex w-full flex-col items-center">
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form className="w-full" onSubmit={handleSubmit}>
        <InputField
          dataTestid="unlock-code-input"
          disabled={
            !privateSalesController.locked || privateSalesController.loading
          }
          error={showCodeValidation ? t('unlock.input.invalid') : undefined}
          id="code-input"
          inputmode="numeric"
          name="code"
          onChange={(e) => {
            const input = formatCodeValue(
              e.currentTarget.value,
              (e.nativeEvent as InputEvent).inputType ===
                'deleteContentBackward',
            );

            setPassword(input);
            setShowValidation(false);
          }}
          placeholder={t('unlock.input.placeholder')}
          textAlign="center"
          type="text"
          value={password}
        />
        <div className="pt-3">
          <Button
            disabled={
              !privateSalesController.locked || privateSalesController.loading
            }
            fullWidth
            label={
              !privateSalesController.locked
                ? t('unlock.enterCta.success')
                : t('unlock.enterCta.default')
            }
            loading={privateSalesController.loading}
            type="submit"
            variant="primary"
          />
        </div>
      </form>
    </div>
  );
};
